import React from 'react';

export const RefreshSVG: JSX.Element = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      /* eslint-disable-next-line max-len */
      d="M13.5602 0.248674L12.0445 1.76537C10.8288 0.662148 9.23181 -9.87774e-05 7.50045 -9.87774e-05C4.54715 -9.87774e-05 1.95606 1.8857 1.04944 4.69407C0.879491 5.21943 1.1681 5.78417 1.69354 5.95294C2.22388 6.12483 2.78298 5.8338 2.95299 5.30944C3.59084 3.32833 5.41908 2.00008 7.50045 2.00008C8.68678 2.00008 9.78184 2.44325 10.6319 3.18144L9.22243 4.56281C8.7224 5.08786 9.08805 5.98169 9.82559 6.00044H14.4165C14.7415 5.99107 15.0009 5.72854 15.0009 5.40351V0.844978C15.0009 0.0933472 14.0915 -0.282937 13.5602 0.248674ZM13.3071 8.05063C12.7776 7.88067 12.217 8.16976 12.0476 8.69412C11.4101 10.6727 9.58183 12.001 7.50045 12.001C6.31413 12.001 5.21907 11.5578 4.36901 10.8196L5.75035 9.43825C6.27851 8.91321 5.91286 8.01937 5.17531 8.00062H0.58316C0.260016 8.01 0 8.27252 0 8.59755V13.1573C0 13.9087 0.908493 14.2849 1.43977 13.7533L2.95549 12.2366C4.17213 13.3386 5.7691 14.0012 7.47233 14.0012C10.4241 14.0012 13.0164 12.1154 13.9227 9.30699C14.1227 8.78194 13.8321 8.19127 13.3071 8.05063Z"
      fill="#061E2D"
    />
  </svg>
);
